<template>
  <div class="container">
    <Box
      :boxTitle="boxTitle[0]">
      <div slot="right">
        <el-button @click="event().change('2')" v-if="showBtn">拒绝</el-button>
        <el-button type="primary" @click="event().change('1')" v-if="showBtn">通过</el-button>
      </div>
      <div slot="info" class="info-column">
        <div class="row">
          <span>状态：</span>
          <span :class="{'red':info.status === 0}">{{info.status | status }}</span>
        </div>
        <div class="row">
          <span>订单编号：</span>
          <span>{{info.orderNum}}</span>
        </div>
        <div class="row">
          <span>类型：</span>
          <span>{{info.type | type }}</span>
        </div>
        <div class="row">
          <span>企业：</span>
          <span>{{info.enterpriseName}}</span>
        </div>
        <div class="row">
          <span>联系人：</span>
          <span>{{info.name}}</span>
        </div>
        <div class="row">
          <span>预订电话号码：</span>
          <span>{{info.mobile}}</span>
        </div>
        <div class="row">
          <span>截止日期：</span>
          <span>{{info.offDate}}</span>
        </div>
      </div>
    </Box>
    <Box
      :boxTitle="boxTitle[1]"
      :noMargin='true'>
      <div slot="info" class="row-line">
        <span>物品清单：</span>
        <el-input
          type="textarea"
          class="textarea"
          v-model="text"
          :autosize="{ minRows: 10, maxRows: 20 }">
          </el-input>
      </div>
      <div class="info-box" slot="info">
        <UpLoadImg
          class="row-img"
          :disabled="true"
          :img="info.pictureList"
          :size="[350, 180]"
          @get-files="getFiles"/>
      </div>
    </Box>
    <el-dialog
      :visible.sync="dialogVisible"
      width="500px">
      <div class="alert-content">
        <el-input
          type="textarea"
          show-word-limit
          placeholder="请填写拒绝原因"
          v-model="body.refusalReason"
          maxlength="100"
          :autosize="{ minRows: 10, maxRows: 20 }">
          </el-input>
      </div>
      <div class="btn">
        <el-button type="primary" @click="event().putCommit()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Box from '@/components/box'
import UpLoadImg from '@/components/upload-img'
import { ElectronicDetails, setAudit } from '@/api/electronic'
export default {
  data() {
    return {
      boxTitle: ['放行信息', '物品信息'],
      body: {
        refusalReason: '',
        status: '',
        uuid: ''
      },
      text: '',
      info: '',
      showBtn: false,
      dialogVisible: false
    }
  },
  filters: {
    status: function(val) {
      if (val === 0) { return '审核中' } else if (val === 1) { return '已通过' } else if (val === 2) { return '拒绝' }
    },
    type: function(val) {
      if (val === 0) return '普通放行'
      else if (val === 1) return '退租放行'
    }
  },
  created() {
    this.network().ElectronicDetails()
  },
  methods: {
    event() {
      return {
        change: (e) => {
          if (e === '2') {
            this.body.status = 2
            this.body.uuid = this.$route.params.id
            this.dialogVisible = true
          } else if (e === '1') {
            this.body.status = 1
            this.body.uuid = this.$route.params.id
            this.network().setAudit()
          }
        },
        putCommit: () => {
          if (!this.body.refusalReason) {
            this.$message({
              type: 'warning',
              message: '请输入原因'
            })
          } else this.network().setAudit()
        }
      }
    },
    network() {
      return {
        ElectronicDetails: async() => {
          const { data } = await ElectronicDetails(this.$route.params.id)
          this.info = data
          this.text = data.content
          if (data.status === 0) {
            this.showBtn = true
          }
        },
        setAudit: async() => {
          await setAudit(this.body)
          this.$message({
            type: 'success',
            message: '成功'
          })
          this.$router.push('/electronic-management')
        }
      }
    },
    getFiles(file, files) {
      // console.log(file,files);
      const arr = []
      files.forEach((item) => {
        if (item.response === undefined) {
          arr.push(item.url.substring(item.url.lastIndexOf('/') + 1))
        } else {
          arr.push(item.response)
        }
      })
      this.info.pictureList = arr
    }
  },
  components: {
    Box,
    UpLoadImg
  }
}
</script>

<style scoped lang="scss">
.btn{
    margin-top: 15px;
    display: flex;
    justify-content: center;
    button{
      width: 70%;
    }
  }
</style>
